export const tutorialTexts = {
  "/minigames/tictactoe": {
    es: {
      title: "Tic Tac Toe",
      description: "Consigue 3 en raya adivinando correctamente pilotos que cumplan con las categorías de cada casilla. También puedes probar el modo Libre, donde debes llenar todas las casillas eligiendo pilotos válidos. ¡Piensa con estrategia!"
    },
    en: {
      title: "Tic Tac Toe",
      description: "Get 3 in a row by correctly guessing drivers that match each square's category. You can also try 'Grid' mode, where you need to fill all the squares with valid drivers. Think strategically!"
    }
  },
  "/minigames/crossword": {
    es: {
      title: "Crucigrama",
      description: "Rellena las palabras relacionadas con Fórmula 1 usando las pistas horizontales y verticales. ¡Demuestra tus conocimientos!"
    },
    en: {
      title: "Crossword",
      description: "Fill in the Formula 1-related words using horizontal and vertical clues. Prove your F1 knowledge!"
    }
  },
  "/minigames/gridgame": {
    es: {
      title: "Grid",
      description: "Acierta los pilotos que formaban parte del año seleccionado según su nacionalidad en cada celda. ¡Atento a las banderas!"
    },
    en: {
      title: "Grid",
      description: "Guess the drivers on the grid based on their nationality shown in each cell. Pay attention to the flags!"
    }
  },
  "/minigames/guessdriver": {
    es: {
      title: "Adivina el Piloto",
      description: "Haz preguntas tipo sí/no para descubrir qué piloto es. Usa lógica deductiva y filtra opciones."
    },
    en: {
      title: "Guess the Driver",
      description: "Ask yes/no questions to find out who the mystery driver is. Use deduction and eliminate options!"
    }
  },
  "/minigames/top10": {
    es: {
      title: "Top 10",
      description: "Adivina el top 10 de una carrera histórica. Introduce los pilotos según su nacionalidad."
    },
    en: {
      title: "Top 10",
      description: "Guess the top 10 of a historical race. Enter drivers by their nationality."
    }
  },
  "/minigames/driverslink": {
    es: {
      title: "Drivers Link",
      description: "Adivina el piloto sabiendo con qué compañeros ha corrido en su carrera. ¡Encuentra el nexo!"
    },
    en: {
      title: "Drivers Link",
      description: "Guess the driver by identifying their teammates over the years. Find the connection!"
    }
  },
  "/minigames/rondo": {
    es: {
      title: "Rondo",
      description: "Contesta palabras de F1 que empiezan por cada letra del abecedario. ¡Supera el rosco completo!"
    },
    en: {
      title: "Rondo",
      description: "Answer F1-related words starting with each letter of the alphabet. Complete the entire round!"
    }
  },
  "/minigames/careerpath": {
    es: {
      title: "Career Path",
      description: "Adivina al piloto según los equipos por los que ha pasado. Obtén una pista por turno."
    },
    en: {
      title: "Career Path",
      description: "Guess the driver based on the teams he raced for. Get one clue at a time!"
    }
  },
  "/minigames/wordle": {
    es: {
      title: "Wordle",
      description: "Adivina el apellido del piloto en 6 intentos. Recibirás pistas sobre letras correctas y su posición."
    },
    en: {
      title: "Wordle",
      description: "Guess the driver's surname in 6 tries. You’ll get clues on correct letters and their position."
    }
  },
  "/minigames/twoTeams": {
    es: {
      title: "2 Equipos, 1 Piloto",
      description: "Introduce un piloto que haya corrido para ambos equipos mostrados. Jugarás 10 intentos consecutivos y se mostrará al final cuántos acertó. ¡Solo hay una respuesta correcta!"
    },
    en: {
      title: "2 Teams, 1 Driver",
      description: "Type a driver who raced for both teams shown. You will play 10 times in a row and final score will be showed at th end of the game. There's only one correct answer!"
    }
  },
  "/minigames/f1Impostor": {
    es: {
      title: "Impostores",
      description: "Selecciona todos los pilotos válidos de una categoría sin elegir a los impostores. ¡Si no escoges a todos los pilotos correctos no ganarás!"
    },
    en: {
      title: "Impostors",
      description: "Pick all correct drivers in a category without selecting the impostor. If you don't pick all the right drivers you won't win!"
    }
  },
  "/minigames/teamGuess": {
    es: {
      title: "Adivina el Equipo",
      description: "Adivina el equipo observando a los pilotos que han corrido para él. ¡Relaciona correctamente!"
    },
    en: {
      title: "Guess the Team",
      description: "Guess the F1 team based on the drivers that have raced for it. Make the right connection!"
    }
  },
  "/minigames/driversConnections": {
    es: {
      title: "Drivers Connection",
      description: "Agrupa 4 pilotos que compartan una categoría oculta. ¡Evita errores y descubre los patrones!"
    },
    en: {
      title: "Drivers Connection",
      description: "Group 4 drivers who share a hidden category. Avoid mistakes and spot the patterns!"
    }
  },
  "/minigames/orderDrivers": {
    es: {
      title: "Ordena Pilotos",
      description: "Coloca los pilotos en el orden correcto según el criterio mostrado (puntos, poles, etc)."
    },
    en: {
      title: "Sort Drivers",
      description: "Put drivers in the correct order based on the given criteria (points, poles, etc)."
    }
  },
  "/minigames/categoryGame": {
    es: {
      title: "Categorías",
      description: "Responde una palabra por categoría que empiece por la misma letra. ¡Rápido y preciso!"
    },
    en: {
      title: "Categories",
      description: "Answer a word for each category starting with the same letter. Be quick and accurate!"
    }
  },
  "/minigames/wordSearch": {
    es: {
      title: "Sopa de Letras",
      description: "Encuentra los apellidos de pilotos. Arrastra el cursor para seleccionar letras. Puedes rendirte si lo necesitas."
    },
    en: {
      title: "Word Search",
      description: "Find surnames of podium finishers. Drag to select letters. You can give up if needed."
    }
  },
 
      "/minigames/top10quali": {
      es: {
        title: "Top 10 Quali",
        description:
          "Adivina los 10 pilotos más rápidos de una sesión de clasificación aleatoria. " +
          "Como pistas verás la bandera del piloto y el tiempo que marcó. " +
          "Desde 2006 se usa Q3; en temporadas anteriores se usa la mejor sesión disponible."
      },
      en: {
        title: "Top 10 Quali",
        description:
          "Guess the 10 fastest drivers from a random qualifying session. " +
          "Hints are the driver’s flag and the lap time. " +
          "From 2006 onwards we use Q3; earlier seasons use the best available session."
      }
    },

    "/minigames/driverSeason": {
      es: {
        title: "Driver Season",
        description:
          "Adivina en qué posición terminó el piloto en cada carrera de una temporada. Verás la bandera del país de cada GP y deberás seleccionar la posición final. ¡Verde si aciertas, rojo si fallas!"
      },
      en: {
        title: "Driver Season",
        description:
          "Guess the driver’s finishing position in every race of a season. You’ll see each GP’s country flag and must pick the final position. Green if correct, red if wrong!"
      }
    },

    "/minigames/tower": {
      es: {
        title: "Tower",
        description:
          "Prueba pilotos para descubrir si pertenecen a una temática secreta (equipo, nacionalidad, campeones, etc.). " +
          "Verás si cada intento es correcto o incorrecto. Tras 15 intentos podrás revelar el tipo de temática con una pista."
      },
      en: {
        title: "Tower",
        description:
          "Try drivers to discover if they belong to a secret theme (team, nationality, champions, etc.). " +
          "Each attempt will be marked as correct or wrong. After 15 attempts you can reveal the theme type using a hint."
      }
    },

    "/minigames/lightsout": {
      es: {
        title: "Lights Out",
        description:
          "Observa el semáforo de 5 luces. Se encenderán una a una y, tras una espera aleatoria, se apagarán todas. " +
          "Pulsa lo más rápido posible cuando se apague la última luz. Si pulsas antes, será salida falsa."
      },
      en: {
        title: "Lights Out",
        description:
          "Watch the 5-light traffic system. Lights will turn on one by one, then after a random delay they will all go out. " +
          "Tap as fast as you can when the last light goes out. If you tap early, it’s a false start."
      }
    },

      "/minigames/anagrams": {
        es: {
          title: "🔀 Anagrams (Apellidos F1)",
          description:
            "Te damos un apellido de piloto con las letras desordenadas.\n\n" +
            "Tu objetivo: reordenar las letras y escribir el apellido correcto.\n" +
            "Tienes 5 intentos.\n" +
            "Puedes escribir con o sin acentos y con mayúsculas/minúsculas (se normaliza automáticamente).\n\n" +
            "Consejo: fíjate en combinaciones típicas y letras repetidas."
        },
        en: {
          title: "🔀 Anagrams (F1 Surnames)",
          description:
            "You get a driver's surname with its letters scrambled.\n\n" +
            "Your goal: reorder the letters and type the correct surname.\n" +
            "You have 5 attempts.\n" +
            "You can type with or without accents and in any case (we normalize automatically).\n\n" +
            "Tip: watch for repeated letters and common letter patterns."
        }
      },

      "/minigames/bingo": {
        es: {
          title: "Bingo",
          description:
            "Completa las 9 casillas antes de que se acabe el tiempo.\n\n" +
            "Cada turno te aparece un piloto: haz clic en una casilla donde ese piloto sea válido.\n" +
            "Si aciertas, la casilla se rellena. Si fallas, pierdes tiempo.\n\n" +
            "No puedes usar el mismo piloto en dos casillas. ¡Piensa rápido!"
        },
        en: {
          title: "Bingo",
          description:
            "Fill all 9 cells before time runs out.\n\n" +
            "Each turn shows a driver: click a cell where that driver is valid.\n" +
            "If correct, the cell is filled. If wrong, you lose time.\n\n" +
            "You can’t use the same driver in two cells. Think fast!"
        }
      },
       "/minigames/race": {
         es: {
           title: "OverCut Racing",
           description:
             "Corre en circuitos inventados en 2D contra coches controlados por la máquina. " +
             "Completa 3 o 5 vueltas y mantente dentro de la pista para no perder velocidad.\n\n" +

             "Controles (PC):\n" +
             "⬆ acelerar · ⬇ frenar · ⬅ ➡ girar · ESPACIO respawn\n\n" +

             "Controles (móvil / tablet):\n" +
             "🕹️ Joystick izquierdo: girar el coche\n" +
             "⬆ Botón derecho superior: acelerar\n" +
             "⬇ Botón derecho inferior: frenar\n\n" +

             "Consejo:\n" +
             "Frena antes de las curvas cerradas y acelera al salir para ganar velocidad."
         },
         en: {
           title: "OverCut Racing",
           description:
             "Race on fictional 2D tracks against AI-controlled cars. " +
             "Complete 3 or 5 laps and stay on track to avoid losing speed.\n\n" +

             "Controls (PC):\n" +
             "⬆ accelerate · ⬇ brake · ⬅ ➡ steer · SPACE respawn\n\n" +

             "Controls (mobile / tablet):\n" +
             "🕹️ Left joystick: steer the car\n" +
             "⬆ Top right button: accelerate\n" +
             "⬇ Bottom right button: brake\n\n" +

             "Tip:\n" +
             "Brake before tight corners and accelerate on exit to gain speed."
         }
       },

       "/minigames/timeline": {
         es: {
           title: "Timeline",
           description:
             "Ordena eventos históricos de Fórmula 1 en el orden cronológico correcto.\n\n" +
             "Usa las flechas para mover cada evento y pulsa 'Validar orden'.\n" +
             "Tienes 3 intentos. Si aciertas todo, ganas. Si no, la partida se termina."
         },
         en: {
           title: "Timeline",
           description:
             "Arrange historical Formula 1 events in the correct chronological order.\n\n" +
             "Use the arrows to move each event and press 'Validate order'.\n" +
             "You have 3 attempts. If everything is correct, you win. Otherwise, the game ends."
         }
       },

       "/minigames/whoIsWho": {
  es: {
    title: "Who Am I?",
    description:
      "Descubre qué piloto es con la menor cantidad de pistas posible.\n\n" +
      "Cómo jugar:\n" +
      "• Pulsa “Mostrar pista” para revelar una nueva pista.\n" +
      "• Escribe el nombre del piloto y pulsa “Adivinar”.\n" +
      "• Tienes un número limitado de intentos y de pistas.\n\n" +
      "Consejo:\n" +
      "Prueba primero con los pilotos más probables según las pistas (época, equipo, nacionalidad, etc.)."
  },
  en: {
    title: "Who Am I?",
    description:
      "Figure out the mystery driver using as few hints as possible.\n\n" +
      "How to play:\n" +
      "• Press “Show hint” to reveal a new clue.\n" +
      "• Type the driver’s name and press “Guess”.\n" +
      "• You have a limited number of attempts and hints.\n\n" +
      "Tip:\n" +
      "Start with the most likely drivers based on the clues (era, team, nationality, etc.)."
  }
},

"/minigames/memory": {
  es: {
    title: "Memory",
    description:
      "Encuentra todas las parejas relacionadas de Fórmula 1.\n\n" +
      "Las cartas no son iguales: cada pareja está unida por una relación real " +
      "(piloto-equipo, piloto-nacionalidad, etc.).\n\n" +
      "Levanta dos cartas por turno y memoriza bien su posición.\n" +
      "¡Conocimiento y memoria van de la mano!"
  },
  en: {
    title: "Memory",
    description:
      "Find all the related Formula 1 pairs.\n\n" +
      "Cards are not identical: each pair is linked by a real relationship " +
      "(driver-team, driver-nationality, etc.).\n\n" +
      "Flip two cards per turn and remember their position.\n" +
      "Knowledge and memory go hand in hand!"
  }
},

"/minigames/teamHistory": {
  es: {
    title: "Historia de Equipo",
    description:
      "Adivina la posición final del equipo en todos o algunos campeonatos de constructores para cada temporada. " +
      "Selecciona la posición correcta en cada año.\n\n" +
      "Pulsa “Rendirse” para revelar el equipo y salir."
  },
  en: {
    title: "Team History",
    description:
      "Guess the team’s final Constructors’ Championship position for some seasons or all seasons. " +
      "Pick the correct position for every year.\n\n" +
      "Press “Give up” to reveal the team and exit."
  }
},

"/minigames/higherLower": {
  es: {
    title: "Higher or Lower",
    description:
      "Compara estadísticas reales de pilotos.\n\n" +
      "Cómo jugar:\n" +
      "• Verás dos pilotos.\n" +
      "• Adivina si el segundo tiene un valor mayor (Higher) o menor (Lower).\n" +
      "• Si fallas, termina la partida.\n\n" +
      "Consejo:\n" +
      "Piensa en eras: puntos y GP dependen mucho de la época."
  },
  en: {
    title: "Higher or Lower",
    description:
      "Compare real driver statistics.\n\n" +
      "How to play:\n" +
      "• You’ll see two drivers.\n" +
      "• Guess if the second one has a higher (Higher) or lower (Lower) value.\n" +
      "• One mistake ends the game.\n\n" +
      "Tip:\n" +
      "Consider eras: points and GP totals vary a lot by period."
  }
},

"/minigames/thirtySeconds": {
  es: {
    title: "30 Seconds",
    description:
      "Se te mostrará una temática (ganadores en un circuito, pilotos de un equipo, compañeros de un piloto, etc.). " +
      "Tienes 30 segundos para escribir tantos pilotos como puedas. Al final verás cuántos son válidos."
  },
  en: {
    title: "30 Seconds",
    description:
      "You will get a theme (winners at a circuit, drivers for a team, teammates of a driver, etc.). " +
      "You have 30 seconds to type as many drivers as you can. At the end you’ll see how many are valid."
  }
},
"/minigames/driverStats": {
  es: {
    title: "Driver Stats",
    description:
      "Se te mostrará un piloto y deberás adivinar sus estadísticas.\n\n" +
      "Casillas:\n" +
      "• Victorias • Podios • Nº equipos • Carreras (aprox.) • Mundiales • Puntos (aprox.) • Temporadas\n\n" +
      "Carreras y puntos se eligen por rangos. Al validar verás cuántas has acertado."
  },
  en: {
    title: "Driver Stats",
    description:
      "You will get a driver and you must guess their stats.\n\n" +
      "Fields:\n" +
      "• Wins • Podiums • Teams • Races (approx.) • World titles • Points (approx.) • Seasons\n\n" +
      "Races and points are selected by ranges. After validating you’ll see how many you got right."
  }
},

"/minigames/abbreviations": {
  es: {
    title: "Abbreviations",
    description:
      "Te mostramos 20 abreviaturas (3 letras) que corresponden a apellidos de pilotos que corrieron desde 1980.\n\n" +
      "Escribe nombres de pilotos usando el buscador.\n" +
      "Si aciertas uno que esté en la lista, se revelará su casilla con una animación.\n\n" +
      "Objetivo: completar las 20."
  },
  en: {
    title: "Abbreviations",
    description:
      "You get 20 three-letter abbreviations (surname prefixes) from drivers who raced since 1980.\n\n" +
      "Type driver names using the search box.\n" +
      "If the driver is on the list, the matching cell will be revealed with an animation.\n\n" +
      "Goal: solve all 20."
  }
},
"/minigames/teamNationality": {
  es: {
    title: "Equipo & Nacionalidad",
    description:
      "Se te mostrará un equipo y una bandera (nacionalidad). " +
      "Escribe pilotos que cumplan esa relación. " +
      "Cada acierto se valida al instante y se añade con animación. " +
      "Objetivo: acertar hasta como mucho 30."
  },
  en: {
    title: "Team & Nationality",
    description:
      "You will get a team and a flag (nationality). " +
      "Type drivers who match that pair. " +
      "Each correct guess is validated instantly and added with an animation. " +
      "Goal: up at most to 30 correct drivers."
  }
 },

};
